import ButtonDropdown from '@rio-cloud/rio-uikit/ButtonDropdown';

import NoContent from '../NoContent';
import TableSkeleton from '../TableSkeleton';
import EditFleetInfoTooltip from './EditFleetInfoTooltip';
import SystemFleetsFormTableRow from './SystemFleetsFormTableRow';

import type { VehicleV2 } from 'API';

import './_styles.scss';

export const tableHeaders = {
    vehicleName: 'Vehicle name',
    vin: 'VIN',
    licensePlate: 'License plate',
    owner: 'Owner',
};

interface Props {
    selectedVehiclesFromEditedFleet?: string[];
    availableVehicles?: VehicleV2[];
    fleetVehicles?: (string | undefined)[];
    isLoading?: boolean;
    selectAll(): void;
    deselectAll(): void;
    onVehicleSelect: (vin: string) => void;
}

const SelectVehiclesTableContent = ({
    selectedVehiclesFromEditedFleet,
    availableVehicles,
    fleetVehicles,
    isLoading,
    selectAll,
    deselectAll,
    onVehicleSelect,
}: Props) => {
    if (isLoading) {
        return <TableSkeleton id='edit-fleets-select-vehicles-table' tableHeaders={tableHeaders} />;
    }

    if (!availableVehicles?.length) {
        return (
            <div data-testid='edit-fleets-select-vehicles-table-no-content' className='SelectVehiclesTable__noContent'>
                <NoContent
                    title='No vehicles found'
                    body={
                        <p>
                            All vehicles are already assigned to a existing fleets
                            <EditFleetInfoTooltip />
                        </p>
                    }
                />
            </div>
        );
    }

    const dropdownItems = [
        {
            value: <p className='SystemFleetsRow__dropdownItemIcons'>Select all vehicles</p>,
            onSelect: selectAll,
        },
        {
            value: <p className='SystemFleetsRow__dropdownItemIcons'>Deselect all vehicles</p>,
            onSelect: deselectAll,
        },
    ];

    return (
        <div className='SelectVehiclesTable' data-testid='edit-fleets-select-vehicles-table'>
            <table
                data-testid='system-fleets-edit-form-selected-vehicles'
                className='table-head-filled table-sticky-in-container table'
            >
                <thead>
                    <tr>
                        <th className='SelectVehiclesTable__headerIcon'>
                            <ButtonDropdown
                                title={<span className='rioglyph rioglyph-checkboxes SelectVehiclesTable__rioIcon' />}
                                items={dropdownItems}
                                bsStyle='muted'
                                iconOnly
                                dropup
                                noCaret
                                className='SelectVehiclesTable__dropbutton'
                            />
                        </th>
                        {Object.values(tableHeaders).map(_ => (
                            <th key={_}>{_}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {availableVehicles.map(_ => (
                        <SystemFleetsFormTableRow
                            key={_.vin}
                            vin={_.vin}
                            name={_?.name}
                            licensePlate={_?.licensePlate}
                            owner={_.owners[0]?.fullName}
                            active={
                                selectedVehiclesFromEditedFleet
                                    ? selectedVehiclesFromEditedFleet?.includes(_.vin)
                                    : fleetVehicles?.includes(_.vin)
                            }
                            onChange={onVehicleSelect}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SelectVehiclesTableContent;
